// extracted by css-extract-rspack-plugin
export default {"root":"DWHD8H","icon":"zg2qJD","title":"GVkSoF","subtitle":"KPgbLS","button":"BClfUz"};